"use strict";

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _class, _temp;

var _lodash = require("lodash");

var _lodash2 = _interopRequireDefault(_lodash);

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _redux = require("redux");

var _apiPaginationView = require("../../actions/apiPaginationView");

var _reactRedux = require("react-redux");

var _propTypes = require("prop-types");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _PaginationViewContext = require("./PaginationViewContext");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var PaginationView = (_temp = _class = function (_Component) {
	_inherits(PaginationView, _Component);

	function PaginationView(props) {
		_classCallCheck(this, PaginationView);

		//defaultOptions
		var _this = _possibleConstructorReturn(this, (PaginationView.__proto__ || Object.getPrototypeOf(PaginationView)).call(this, props));

		_this.setOptions = function (options) {
			_this.options = _lodash2.default.merge({}, _this.options, options);
		};

		_this.loadData = function () {
			_this.props.dispatch((0, _apiPaginationView.apiPaginationView)(_lodash2.default.assign({}, _this.options, {
				RESET: true
			})));
		};

		_this.loadMore = function () {
			var skip = _lodash2.default.get(_this.props, ["paginationView", _this.props.options.VIEW, "SKIP"]);
			_this.props.dispatch((0, _apiPaginationView.apiPaginationView)(_lodash2.default.assign({}, _this.options, {
				SKIP: _this.options.LIMIT + skip
			})));
		};

		_this.options = {
			SKIP: 0,
			LIMIT: 20,
			RESET: false,
			SORT: {},
			OPTIONS: {}
		};
		return _this;
	}

	_createClass(PaginationView, [{
		key: "componentDidMount",
		value: function componentDidMount() {
			this.options = _lodash2.default.assign({}, this.options, this.props.options);
			if (this.props.preventInitialLoad) {
				this.loadData();
			}
		}
	}, {
		key: "getContextData",
		value: function getContextData() {
			var view = _lodash2.default.get(this.props, ["paginationView", this.props.options.VIEW], {});

			var skip = _lodash2.default.get(this.props, ["paginationView", this.props.options.VIEW, "SKIP"], 0);
			var limit = _lodash2.default.get(this.props, ["paginationView", this.props.options.VIEW, "LIMIT"], 0);

			var start = view.RESET ? 1 + skip : 1;
			var end = skip + limit;

			var contextData = _lodash2.default.assign({}, view, {
				start: start,
				end: end <= view.MAX_RESULTS ? end : view.MAX_RESULTS,
				fullLoading: view.loading && view.fullLoading,
				loadData: this.loadData,
				loadMore: this.loadMore,
				setOptions: this.setOptions,
				loadMorePossible: view.MAX_RESULTS > view.SKIP + view.LIMIT
			});
			return contextData;
		}
	}, {
		key: "render",
		value: function render() {
			return _react2.default.createElement(
				_PaginationViewContext.PaginationViewContext.Provider,
				{ value: this.getContextData() },
				this.props.children
			);
		}
	}]);

	return PaginationView;
}(_react.Component), _class.propTypes = {
	preventInitialLoad: _propTypes2.default.bool,
	options: _propTypes2.default.shape({
		VIEW: _propTypes2.default.string.isRequired,
		SKIP: _propTypes2.default.number,
		LIMIT: _propTypes2.default.number,
		RESET: _propTypes2.default.bool,
		SORT: _propTypes2.default.object,
		OPTIONS: _propTypes2.default.object
	}).isRequired
}, _class.defaultProps = {
	preventInitialLoad: true
}, _temp);
exports.default = (0, _redux.compose)((0, _reactRedux.connect)(function (state) {
	return {
		paginationView: state.paginationView
	};
}))(PaginationView);